import { useState } from 'react';
import { KPIDashboard } from '@/components/Admin/KPIDashboard';
import { SwipeModeration } from '@/components/Admin/SwipeModeration';
import { UserManagement } from '@/components/Admin/UserManagement';
import { ThemeModeration } from '@/components/Admin/ThemeModeration';
import { ThemeCreationModal } from '@/components/Admin/ThemeCreationModal';
import { GamenicsSoundManagement } from '@/components/Admin/GamenicsSoundManagement';
import { SiteAssetManagement } from '@/components/Admin/SiteAssetManagement';
import { PromptManagement } from '@/components/Admin/PromptManagement';
import { MarketModeration } from '@/components/Admin/MarketModeration';
import { OpsEvents } from '@/components/Admin/OpsEvents';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

export const GodMode = () => {
    const [isThemeModalOpen, setIsThemeModalOpen] = useState(false);

    return (
        <div className="min-h-screen pt-8 pb-16 px-4 md:px-8 max-w-7xl mx-auto space-y-8">
            <header className="flex justify-between items-center mb-8">
                <div>
                    <h1 className="text-4xl font-display font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500">
                        GOD MODE
                    </h1>
                    <p className="text-muted-foreground text-sm font-mono">管理者コンソール v2.0</p>
                </div>
                <div className="flex items-center gap-4">
                    <Button variant="neon" className="border-red-500 text-red-500 hover:bg-red-500 hover:text-ink" onClick={() => setIsThemeModalOpen(true)}>
                        + テーマ作成
                    </Button>
                    <Badge variant="outline" className="border-red-500 text-red-500 px-4 py-1">SECURE CONNECTION</Badge>
                </div>
            </header>

            <Tabs defaultValue="dashboard">
                <TabsList className="bg-cream-2 border-2 border-ink/15 w-full justify-start h-12 p-1 mb-8">
                    <TabsTrigger value="dashboard" className="w-32">ダッシュボード</TabsTrigger>
                    <TabsTrigger value="moderation" className="w-32">ボイス審査</TabsTrigger>
                    <TabsTrigger value="themes" className="w-32">テーマ審査</TabsTrigger>
                    <TabsTrigger value="market" className="w-32">マーケット審査</TabsTrigger>
                    <TabsTrigger value="users" className="w-32">ユーザー管理</TabsTrigger>
                    <TabsTrigger value="sounds" className="w-32">効果音管理</TabsTrigger>
                    <TabsTrigger value="site-assets" className="w-32">サイト画像</TabsTrigger>
                    <TabsTrigger value="prompts" className="w-32">お題管理</TabsTrigger>
                    <TabsTrigger value="ops-events" className="w-32">運用イベント</TabsTrigger>
                </TabsList>

                <TabsContent value="dashboard" className="space-y-4">
                    <KPIDashboard />
                </TabsContent>

                <TabsContent value="moderation" className="space-y-4">
                    <div className="flex justify-center">
                        <SwipeModeration />
                    </div>
                </TabsContent>

                <TabsContent value="themes" className="space-y-4">
                    <ThemeModeration />
                </TabsContent>

                <TabsContent value="market" className="space-y-4">
                    <MarketModeration />
                </TabsContent>

                <TabsContent value="users" className="space-y-4">
                    <UserManagement />
                </TabsContent>
                
                <TabsContent value="sounds" className="space-y-4">
                    <GamenicsSoundManagement />
                </TabsContent>

                <TabsContent value="site-assets" className="space-y-4">
                    <SiteAssetManagement />
                </TabsContent>

                {/* 週替わりお題（トキワ荘「お題スケッチ」/ サロン「今週の一筆」）は Admin 手動運用（決定3） */}
                <TabsContent value="prompts" className="space-y-4">
                    <PromptManagement />
                </TabsContent>

                {/* 握りつぶされた失敗のうち「永久に失われる」4系統だけを記録（migration 0029） */}
                <TabsContent value="ops-events" className="space-y-4">
                    <OpsEvents />
                </TabsContent>
            </Tabs>

            {isThemeModalOpen && (
                <ThemeCreationModal
                    onClose={() => setIsThemeModalOpen(false)}
                    onSuccess={() => alert('テーマを作成しました！')}
                />
            )}
        </div>
    );
};
